<ion-header>
  <app-header [backRoute]="['/home']"></app-header>
</ion-header>

<ion-content class="content">
  <div class="video-chat-complete-container">
    <span class="primary-color complete-message">{{'__VIDEOCHAT_SESSION_COMPLETE__' | translate}}</span>
    <span class="description">{{'__VIDEOCHAT_SESSION_COMPLETE_TEXT__' | translate}}</span>

      <div class="btn">
        <button (click)="goHome()">
          <img src="assets/img/exit-btn.svg">
        </button>
        <span>{{'__VIDEOCHAT_SESSION_EXIT__' | translate}}</span>
      </div>
  </div>

  <app-footer-logo></app-footer-logo>
</ion-content>
